/* eslint-disable no-unused-vars */
import React, {useEffect} from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Header from "../InitialPage/Sidebar/Header";
import Sidebar from "../InitialPage/Sidebar/Sidebar";
// import SellerNotifications from "../InitialPage/Sidebar/SellerNotifications";

import { pagesRoute, posRoutes, publicRoutes, protectedRoutes } from "./router.link";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import ThemeSettings from "../InitialPage/themeSettings";
import Loader from "../feature-module/loader/loader";
import ProtectiveRoutes from "./ProtectiveRoutes";
import { chatLoader } from "../utils/widgetLoader";


const AllRoutes = () => {
  const location = useLocation();
const filteredRoutes = protectedRoutes.filter(route => {
  return !(route.id === 11 && route.name === "saleslist");
});
 useEffect(() => {
  const doc = document.getElementById("root");

  if (location.pathname === "/signin") {
    // Only hide the root div when on the signin page
    doc?.style.setProperty('display', 'none');
  } else {
    doc?.style.setProperty('display', 'block');
  }

  const token = localStorage.getItem("accessToken");
  const userId = localStorage.getItem("userId");
  if (token && userId) {
    if(localStorage.getItem("tenantId") != "n4Xc96g6qyNcrq5dD" && localStorage.getItem("tenantId")  != "8wNWEtTEdgoywriNX") 
    chatLoader();
  }
}, [location]);

  const data = useSelector((state) => state.toggle_header);

  const language = useSelector((state) => state.language || "en");
  const HeaderLayout = () => (
    <div className={`main-wrapper ${data ? "header-collapse" : ""}`}>
     
      <span className={`${language === 'ar' ? 'rtl' : 'ltr'}`}>
        <Header />
        {/* <SellerNotifications/> */}
        <Sidebar />
        <Outlet />
        <ThemeSettings />
        <Loader />
      </span>
    </div>
  );


  const Authpages = () => (
    <div className={data ? "header-collapse" : ""}>
      <Outlet />
      <Loader />
      <ThemeSettings />
    </div>
  );

  const Pospages = () => (
    <div>
      <Header />
      <Outlet />
      <Loader />
      <ThemeSettings />
    </div>
  );

  return (
    <div>
      <Loader />
      <Routes>
      <Route path="/pos" element={<Pospages />}>
          {posRoutes.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>

      

        <Route path={"/"} element={<HeaderLayout />}>
          {filteredRoutes.map((route, id) => {
            return <Route path={route.path} element={<ProtectiveRoutes>{route.element}</ProtectiveRoutes>} key={id} />
          })}
        </Route> 
        <Route path={"/"} element={<HeaderLayout />}>
          {publicRoutes.map((route, id) => {
            return <Route path={route.path} element={route.element} key={id} />
          })}
        </Route>

        <Route path={"/"} element={<Authpages />}>
          {pagesRoute.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route> 
       
        

        {/* <Route path={"/expenses/"} element={<HeaderLayout />}>
          {expensesRoutes.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route> */}
      </Routes>
    </div>
  );
};
export default AllRoutes;
